import api, { fetchAllPages } from "./client";

export const turnosApi = {
  getAll: (params = {}) => fetchAllPages("/turnos/", params),
  create: (data) => api.post("/turnos/", data),
  update: (id, data) => api.patch(`/turnos/${id}/`, data),
  availability: async ({ barbero, fecha, servicios }) => {
    const params = new URLSearchParams({ barbero, fecha });
    servicios.forEach((id) => params.append("servicios", id));
    return (await api.get(`/disponibilidad/?${params.toString()}`)).data;
  },
  changeStatus: (id, action) => api.patch(`/turnos/${id}/${action}/`),
};
